<script>
export default {
  name: 'FullFormIcon',
};
</script>

<template>
  <svg
    width="22px"
    height="22px"
    viewBox="0 0 22 22"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
  >
    <!-- Generator: Sketch 46.2 (44496) - http://www.bohemiancoding.com/sketch -->
    <title>icon/full form</title>
    <desc>Created with Sketch.</desc>
    <defs />
    <g id="Symbols" 
       stroke="none" 
       stroke-width="1" 
       fill="none" 
       fill-rule="evenodd">
      <g id="icon/full-form" fill="#7C8482">
        <path
          id="Fill-1"
          d="M6.0247438,17.4279674 C6.01423034,17.4279674 6.00371688,17.4279674 5.99224765,17.4279674 C5.99224765,17.4279674 5.02309775,17.5216328 4.94950353,17.5053847 C4.63696703,17.4346578 4.39898051,17.1555732 4.39898051,16.817231 L4.39898051,2.62023634 C3.84654596,2.62788249 3.29984601,2.67758249 2.77608453,2.7980094 C2.32400573,2.90218823 2,3.30361127 2,3.76811506 L2,17.4690655 C2,18.0912712 2.56294802,18.5376154 3.1765518,18.431525 C5.06993044,18.104652 7.16975522,18.5012962 9.08893963,19.5966076 C8.10449742,18.1400154 6.80847449,17.4470828 6.0247438,17.4279674 M5.79822652,1.00880959 C5.54590347,1.03270382 5.35474964,1.24870764 5.35474964,1.50294223 L5.35474964,15.993358 C5.35474964,16.279133 5.59560346,16.4894022 5.88137843,16.4741099 C7.2787129,16.4024272 9.47889343,17.7127866 10.6219933,20.4061441 L10.6219933,4.9341534 C9.45595497,2.18727292 7.19173791,0.878824986 5.79822652,1.00880959 M19.2019328,2.79323055 C16.6997292,2.22741523 13.7769872,2.94137477 11.3780067,4.9341534 L11.3780067,20.6479536 C13.6575161,18.7536192 16.4120427,18.0148097 18.8263155,18.4324808 C19.4380078,18.5385712 20,18.0903155 20,17.4690655 L20,3.76811506 C20,3.29405357 19.6635693,2.89740939 19.2019328,2.79323055"
        />
      </g>
    </g>
  </svg>
</template>
